export default __webpack_public_path__ + "static/media/Deves.0d0cf6b7.png";